<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6L10Yc/tc-custom/9781426842092.jpg?1731056023143" alt="This image is the cover for the book Exposed: Sheikh's Mistress, For Love or Money"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Exposed: Sheikh's Mistress, For Love or Money
      </h1>
      <p class="bookDescription body article font2">
        <b>A sheikh can’t resist the woman he once rejected in this classic second chance romance from a <i>USA Today</i>–bestselling author.</b><br/><br/>Is Sheikh Hashim Al Aswad back with Sienna Baker, the model he nearly married, before photos exposing her past were revealed?<br/><br/>But Hashim doesn’t know the truth behind the “scandal.” And though he may just want to bed her, not wed her, with a passion this hot, can he walk away?<br/><br/><i>Originally published in 2005.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon Kendrick
      </h2>
      
      <p class="authorDescription body article">Sharon Kendrick started story-telling at the age of eleven and has never stopped. She likes to write fast-paced, feel-good romances with heroes who are so sexy they&rsquo;ll make your toes curl! She&#160;lives in the beautiful city of Winchester &ndash; where she can see the cathedral from her window (when standing on tip-toe!). She has two children, Celia and Patrick and her passions include music, books, cooking and eating &ndash; and drifting into daydreams while working out new plots.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5267d287